import DatePicker from 'react-date-picker';

import { ReactComponent as CalendarIcon } from '../../assets/icons/calendar.svg';
import { Container, Error, Label } from './styles';
import { IoMdCloseCircle } from 'react-icons/io';

interface IProps {
  placeholder: string;
  value: Date | undefined;
  onChange: (value: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  isOpen?: boolean;
  onCalendarClose?: (() => any) | undefined;
  disabled?: boolean;
  error?: boolean;
  errorMessage?: string;
  labelTxt?: string;
}

export const StyledDateInput: React.FC<IProps> = ({
  placeholder,
  value,
  onChange,
  minDate,
  maxDate,
  isOpen,
  onCalendarClose,
  disabled = false,
  error = false,
  errorMessage = '',
  labelTxt
}) => (
  <Container dateValue={value} error={error}>
    {labelTxt && <Label>{labelTxt}</Label>}
    <DatePicker
      minDate={minDate}
      maxDate={maxDate}
      isOpen={isOpen}
      onCalendarClose={onCalendarClose}
      onChange={onChange}
      value={value}
      calendarIcon={value ? null : <CalendarIcon />}
      clearIcon={value ? <IoMdCloseCircle size={18} color="#F58220" /> : null}
      locale="pt-br"
      dayPlaceholder={placeholder}
      monthPlaceholder=""
      yearPlaceholder=""
      disabled={disabled}
    />
    {error && errorMessage !== '' && <Error>{errorMessage}</Error>}
  </Container>
);
